import React from 'react'
import AnchorLink from 'react-anchor-link-smooth-scroll'


export class HeaderBoxes extends React.PureComponent {
    render() {
        return (
            <div className="head-box-container d-flex flex-wrap justify-content-around w-100 container">
                <div className="head-box-outer ">    
                    <div className="box">
                        <div className="bg-black-padding px-2 py-3">          
                                <div className="head-box mx-2 p-4 d-flex flex-column justify-content-start align-items-center">
                                    <h3>About Complex</h3>
                              
                                    <p className="text-center">About Complex
                                    Complex is a Brazilian Jiu Jitsu club founded in 2018 with the aim of spreading the martial art that has so positively influenced our lives. Are you interested in self-defense, is your goal to participate in competitions and to win medals or do you just want to stay fit in a fun way, there is a place for everyone at Complex. Our instructors are still actively participating in competitions and have already won several medals at national, European and international level.</p>
                            
                            </div>
                        </div> 
                    </div>
                </div>

                
                <div className="head-box-outer ">    
                    <div className="box">
                        <div className="bg-black-padding px-2 py-3">          
                                <div className="head-box head-box-enlarged mx-2 p-4 d-flex flex-column justify-content-start align-items-center">
                                    <h3 className="text-center">About Braziliaanse Jiu Jitsu</h3>
                                
                                    <p className="text-center">
Brazilian Jiu Jitsu is a martial art that focuses on ground fighting. Men
                                    tries to knock down the opponent and then always go to one
                                    to bring a more dominant position to eventually let the opponent tap
                                    by means of a clamp or stranglehold. Jiu Jitsu has its origins in Japan and
                                    is derived from Judo. In 1914, Mitsuyo Maeda brought the sport to Brazil
                                    where one of his students Helio Gracie had adapted certain techniques
                                    so a smaller, weaker person is a heavier and stronger opponent
                                    could beat. That form of Jiu Jitsu is what we do today
                                    Call Brazilian Jiu Jitsu</p>
                                 
                            </div>
                        </div> 
                    </div>
                </div>
                <div className="head-box-outer ">    
                    <div className="box">
                        <div className="bg-black-padding px-2 py-3">          
                                <div className="head-box mx-2 p-4 d-flex flex-column justify-content-start align-items-center">
                                    <h3>Where do i start?</h3>
                                    <p className="text-center">
Where do i start?
Feel free to drop by for a free trial lesson. In this session you will become acquainted with all the basic skills that bjj has to offer. You also get the chance to train together with real experienced athletes. To start, simply click on the button below and let us know via our contact form during which training you will visit!</p>
                                    <button  className="button-white"><AnchorLink  className="nav-link text-dark" href='#contact'>Participate now!</AnchorLink></button>
                            </div>
                        </div> 
                    </div>
                </div>
            </div>
        )
    }
}

export default React.memo(HeaderBoxes)
